<script setup lang="ts">
import { ref } from 'vue';

import { useDrawer } from '@/stores/useDrawer.ts';
import { useNavigationLoading } from '@/stores/useNavigationLoading.ts';
import AppBarComponent from '@/components/AppBarComponent.vue';
import NavigationDrawerComponent from "@/components/NavigationDrawerComponent.vue";
import AppDrawer from '@/components/ui/AppDrawer.vue';

const { drawerState } = useDrawer()
const { isNavigating } = useNavigationLoading()
const navbar = ref<typeof NavigationDrawerComponent | null>(null)

const toggleDrawer = (): void => {
  navbar.value?.toggleDrawer()
}
</script>

<template>
  <v-app>
    <v-progress-linear
      v-if="isNavigating"
      class="global-loading-bar"
      color="primary"
      height="3"
      indeterminate
    />

    <AppDrawer v-model="drawerState" />
    <NavigationDrawerComponent ref="navbar" />
    <AppBarComponent @toggle-drawer="toggleDrawer" />

    <v-main>
      <v-container class="position-relative">
        <slot />
      </v-container>
    </v-main>
  </v-app>
</template>

<style scoped>
.v-app {
  background-color: #fff;
}

.global-loading-bar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 3000;
}
</style>
